<template>
  <el-card class="card-main">
    <el-form inline ref="searchForm" :model="searchForm">
      <el-form-item prop="keyWord">
        <el-input v-model="searchForm.keyWord" placeholder="请输入名称/编号" clearable></el-input>
      </el-form-item>
      <el-form-item prop="typeId">
        <el-select v-model="searchForm.facilityTypeId" placeholder="请选择类型" filterable clearable>
          <el-option v-for="item in typeList" :key="item.facilityTypeId" :label="item.facilityTypeName" :value="item.facilityTypeId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="projectName">
        <el-select v-model="searchForm.projectId" placeholder="请选择所属项目" filterable clearable>
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName" :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="mb20">
      <el-button @click="onAdd" type="primary" icon="el-icon-plus" v-show="$ButtonShow('FAC_ADD_01')">新增</el-button>
      <el-button @click="isShow = true" type="primary" v-show="$ButtonShow('FAT_ADD_01')">类型设置</el-button>
      <CustomExport type="3" :params="searchForm" v-show="$ButtonShow('FAC_DOWNLOAD_01')"></CustomExport>
    </div>

    <div class="tips">资产数量统计： {{ total }}</div>

    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="编号" show-overflow-tooltip prop="facilityNo"></el-table-column>
      <el-table-column label="类型" show-overflow-tooltip prop="facilityTypeName"></el-table-column>
      <el-table-column label="名称" show-overflow-tooltip prop="facilityName"></el-table-column>
      <el-table-column label="位置描述" show-overflow-tooltip prop="address"></el-table-column>
      <el-table-column label="所属项目" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="操作" width="160px">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row.facilityId)">查看</el-button>
          <template>
            <el-button type="text" @click="onEdit(row.facilityId)" v-show="$ButtonShow('FAC_EDT_01')">编辑</el-button>
            <!-- deviceNumber有值不可以删 -->
            <el-button type="text" @click="onDelete(row.facilityId)" v-show="$ButtonShow('FAC_DEL_01')" v-if="!row.deviceNumber">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination
      @size-change="loadData"
      @current-change="loadData"
      :current-page.sync="page"
      :page-size.sync="size"
      :total="total">
    </global-pagination>

    <TypeSet v-if="isShow" :isShow.sync = "isShow"></TypeSet>
  </el-card>
</template>
<script>
import CustomExport from '../customExport/Index.vue'
import TypeSet from './TypeSet.vue'
import keepAlive from '@/mixins/keepAlive.js'

//
export default {
  name: 'PointList',
  mixins: [keepAlive],
  components: { TypeSet, CustomExport },
  data () {
    return {
      searchForm: {
        keyWord: '',
        facilityTypeId: (this.$route.query.facilityTypeId) || '',
        projectId: (this.$route.query.projectId) || ''
      },
      isShow: false,
      loading: false,
      typeList: [],
      tableData: [],
      page: 1,
      size: 10,
      total: 0
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }
  },
  created () {
    this.getType()
    this.loadData()
  },
  methods: {
    // 设施类型列表
    getType () {
      this.$axios.get(this.$apis.patrol.selectFacilityTypeByList).then(res => {
        this.typeList = res.list || []
      })
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.patrol.selectFacilityByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.loadData()
    },

    onAdd () {
      this.$router.push('/patrol/patrolPoint/add')
    },

    onDetail (id) {
      this.$router.push({ name: 'patrolPointDetail', params: { id } })
    },

    onEdit (id) {
      this.$router.push({
        name: 'patrolPointEdit',
        params: { id }
      })
    },

    onDelete (facilityId) {
      this.$confirm('确认删除该巡查点位，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.patrol.deleteFacility, {
          facilityId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }

}
</script>

<style scoped lang='scss'>
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  .tips{
    height: 40px;
    background: #FBFBFB;
    border: 1px solid #EBEBEB;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    padding-left: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #565656;
  }
</style>
